export default "__VITE_ASSET__CTQzDE64__"